import { 
    FETCH_INVOICES,
    LOG_OUT_USER,
    ADD_INVOICE,
    UPDATE_INVOICE,
    DELETE_INVOICES,
    FETCH_SINGLE_INVOICE,
    FETCH_UNIT_UTILITIES,
    SEND_INVOICE,
    CREATE_PROPERTY_INVOICES
 } from "../../actions/actionTypes";

 
const fetchInvoicesReducer = (invoices, payload) => {
    let newInvoices = payload.offset == "" ? {} : { ...invoices };
    if (payload.invoices){
        for(let invoice of payload.invoices){
            newInvoices[invoice.invoiceId] = invoice;
        }
    }
    return newInvoices;
}

const fetchSingleInvoiceReducer = (invoices, payload) => {

    let newInvoices = { ...invoices };
    newInvoices[payload.invoice.invoiceId] = payload.invoice;

    return newInvoices;
}

const fetchUtilityInvoiceReducer = (invoices, payload) => {

    let newInvoices;
    newInvoices = { ...invoices, ...payload.invoices };

    return newInvoices;
}

const addInvoiceReducer = (invoices, payload) => {
    let newInvoices = {
        ...invoices,
        [payload.invoice.invoiceId]: {...payload.invoice}
    };
    return newInvoices;
}

const updateInvoiceReducer = (invoices, payload) => {
    let newInvoices = {
        ...invoices,
        [payload.invoice.invoiceId]: {
            ...invoices[payload.invoiceId],
            ...payload.invoice
        }
    };
    return newInvoices;
}


const deleteInvoicesReducer = (invoices, payload) => {
    let newInvoices = { ...invoices };
    for (const invoiceId of payload.invoiceIds) {
      delete newInvoices[invoiceId];
    }
    return newInvoices;
  };


const sendInvoiceSMSReducer = (invoices, payload) => {
    let newInvoices = {
        ...invoices
    }
    for (let invoice of payload.invoices){
        if(invoice.id in invoices){
            newInvoices[invoice.id] = {
                ...invoices[invoice.id],
                message: invoice.message ? invoice.message.id : ""
            }
        }   
    }
    return newInvoices;
}

const invoicesReducer = (state={}, action) => {
    let invoices = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_INVOICES:
                return fetchInvoicesReducer(invoices, action.payload);
            case CREATE_PROPERTY_INVOICES:
                return fetchInvoicesReducer(invoices, action.payload);
            case FETCH_SINGLE_INVOICE:
                return fetchSingleInvoiceReducer(invoices, action.payload);
            case FETCH_UNIT_UTILITIES:
                return fetchUtilityInvoiceReducer(invoices, action.payload);
            case ADD_INVOICE:
                return addInvoiceReducer(invoices, action.payload);
            case UPDATE_INVOICE:
                return updateInvoiceReducer(invoices, action.payload);
            case DELETE_INVOICES:
                return deleteInvoicesReducer(invoices, action.payload);
            case SEND_INVOICE:
                return sendInvoiceSMSReducer(invoices, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return invoices;
        }
    }
    return invoices;
}

export default invoicesReducer;